import { render, staticRenderFns } from "./UsersView.vue?vue&type=template&id=56c6248a&scoped=true"
import script from "./UsersView.vue?vue&type=script&lang=js"
export * from "./UsersView.vue?vue&type=script&lang=js"
import style0 from "./UsersView.vue?vue&type=style&index=0&id=56c6248a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c6248a",
  null
  
)

export default component.exports